import { AnimatePresence, motion } from "framer-motion";
import { FrostLayer } from "../FrostLayer";

export const StoryViewer = ({ person, zoom, bottom, hidden }) => (
  <motion.div
    data-testid="story-viewer"
    data-person={person.id}
    className="absolute left-3 right-3 overflow-hidden rounded-[28px] bg-[#14151B] shadow-[0_20px_50px_-20px_rgba(8,9,13,.5)]"
    initial={false}
    animate={{ top: zoom ? 62 : 200, left: zoom ? 6 : 12, right: zoom ? 6 : 12, opacity: hidden ? 0 : 1 }}
    style={{ bottom }}
    transition={{ type: "spring", stiffness: 260, damping: 32 }}
  >
    <AnimatePresence mode="popLayout" initial={false}>
      <motion.img
        key={person.id}
        src={person.story.image}
        alt={`${person.name}'s story: ${person.story.caption}`}
        className="absolute inset-0 h-full w-full object-cover"
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.45 }}
      />
    </AnimatePresence>
    <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/45 to-transparent" aria-hidden />
    <div className="absolute inset-x-3 top-3">
      <div className="h-[3px] overflow-hidden rounded-full bg-white/35">
        <div key={person.id} className="story-progress h-full rounded-full bg-white" />
      </div>
      <div className="mt-2.5 flex items-center gap-2">
        <img src={person.avatar} alt="" className="h-7 w-7 rounded-full border border-white/70 object-cover" />
        <span className="text-[13px] font-semibold text-white" data-testid="story-viewer-name">
          {person.isMe ? "Your story" : person.name}
        </span>
        <span className="text-[12px] text-white/75">{person.story.time}</span>
      </div>
    </div>
    <FrostLayer src={person.story.image} height="40%" />
    <p className="absolute inset-x-4 bottom-4 text-center text-[15px] font-semibold leading-snug text-white" data-testid="story-viewer-caption">
      {person.story.caption}
    </p>
  </motion.div>
);
